import { TUTORIAL_STATES } from "./TutorialActions";

const _nullState = {
  isTutorial: true,
  activeTutorial: "home-overview", // first-video, video-detail, home-overview
  activeStep: 1,
  isVistComplete: false,
  openVideoModal: false,
  totalSteps: 5,
};

export const tutorials_states = (state = _nullState, { type, status }) => {
  switch (type) {
    case TUTORIAL_STATES:
      return { ...state, ...status };
    default:
      return state;
  }
  
};
